import { create } from "zustand";

const STORAGE_KEY = "selected-account-id";

interface SelectedAccountStore {
	accountId: string | null;
	setAccountId: (id: string | null) => void;
}

export const useSelectedAccountStore = create<SelectedAccountStore>((set) => ({
	accountId:
		typeof window !== "undefined"
			? window.localStorage.getItem(STORAGE_KEY)
			: null,
	setAccountId: (id) => {
		if (typeof window !== "undefined") {
			if (id) window.localStorage.setItem(STORAGE_KEY, id);
			else window.localStorage.removeItem(STORAGE_KEY);
		}
		set({ accountId: id });
	},
}));
